import { shotQualLabel } from "../ShotQualLabel";

/**
 * "Shot Qual (TS%)" as a two-line column head, so the column is no wider than TS%, ORB% and TOV% (Trevor,
 * 2026-09-30; the scale added 2026-10-10).
 */
const ShotQualityLabel = shotQualLabel("TS%");

export default ShotQualityLabel;
